<template>
  <div v-if="warningInfo.show" class="transaction-item-warning" :class="{ prominent: isProminent }">
    <div class="icon">
      <ExclamationIcon v-if="isProminent" fill-current-color :size="16" />
      <DelayIcon v-else />
    </div>
    <div class="text" v-html="warningInfo.message" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import DelayIcon from '@/components/icons/DelayIcon.vue';
import { BetHistoryEntity, PayChannelSuccessRate, TransStatement } from '@/common/api/model';
import { checkBetTransactionWarning, checkTransactionWarning } from '@/common/transaction-utils';
import { TransactionType } from '@/common/config';
import ExclamationIcon from '@/components/icons/ExclamationIcon.vue';
import { namespace } from 'vuex-class';
import { ChatWarnings } from '@/store/chatWarning/chatWarning.types';

const chatWarning = namespace('chatWarning');

@Component({ components: { DelayIcon, ExclamationIcon } })
export default class TransactionItemWarning extends Vue {
  @chatWarning.Getter('chatWarnings') chatWarnings!: ChatWarnings;

  @Prop({ required: true }) readonly transaction!: TransStatement | BetHistoryEntity;
  @Prop() readonly transactionMethodSuccessRate!: PayChannelSuccessRate[] | null | undefined;
  @Prop() readonly transactionType!: TransactionType;

  get warningInfo() {
    const { transaction, transactionMethodSuccessRate, transactionType: type } = this;

    if (type === TransactionType.Bet) {
      return checkBetTransactionWarning({
        transaction: transaction as BetHistoryEntity,
        chatWarnings: this.chatWarnings,
      });
    }

    return checkTransactionWarning({
      transaction: transaction as TransStatement,
      transactionMethodSuccessRate,
      type,
      chatWarnings: this.chatWarnings,
    });
  }

  /**
   * This is a kind of notification that has need to grab more attention.
   */
  get isProminent() {
    return this.warningInfo?.kind === 'prominent';
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variable.scss';

.transaction-item-warning {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  background-color: $tr-item-warning-background;
  color: $tr-item-warning-color;

  &.prominent {
    background-color: $tr-item-notification-prominent-background;
  }
}
</style>
